import { FaDollarSign, FaUniversity, FaUser, FaChartBar, FaCog } from 'react-icons/fa'
import { IoCalendar, IoReader, IoLogoWhatsapp } from 'react-icons/io5'
import { BANKING_ENABLED, WHATSAPP_ENABLED } from 'services/features'

const NavbarData = [
  {
    label: 'Agenda',
    id: 'agenda',
    path: '/business',
    icon: <IoCalendar/>
  },
  {
    label: 'Financeiro',
    id: 'financial',
    path: '/business/financial',
    icon: <FaDollarSign/>
  },
  /*
    O Cutilei Pay ainda não foi lançado: em produção o item não entra na navbar. Ver
    `services/features.js` para o porquê de a permissão não bastar como trava.
  */
  ...(BANKING_ENABLED ? [{
    label: 'Cutilei Pay',
    id: 'banking',
    path: '/business/banking',
    icon: <FaUniversity/>
  }] : []),
  /*
    Gestão WhatsApp: em teste, fora de produção (ver `services/features.js`). O code `whatsapp`
    não é cadastrado na API de propósito: some para o profissional (ver `services/areaCodes.js`).
  */
  ...(WHATSAPP_ENABLED ? [{
    label: 'WhatsApp',
    id: 'whatsapp',
    path: '/business/whatsapp',
    icon: <IoLogoWhatsapp/>
  }] : []),
  {
    label: 'Clientes',
    id: 'customers',
    path: '/business/customers',
    icon: <FaUser/>
  },
  {
    label: 'Histórico de agendamentos',
    id: 'schedule_history',
    path: '/business/schedules',
    icon: <IoReader/>
  },
  {
    label: 'Estatísticas do salão',
    id: 'dashboard',
    path: '/business/dashboard',
    icon: <FaChartBar/>
  },
  {
    label: 'Configurações',
    id: 'business_config',
    path: '/business/config',
    icon: <FaCog/>
  },
]

export default NavbarData
